import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase-config';

const emptyDefaults = { fetchItems: [], deliverItems: [] };

// Suggestions for the Fetch and Deliver popups. Cleared on every robot change
// so another robot's items are never offered while (or after) a read is pending.
const useActionDefaultItems = (savedRobot) => {
  const [defaults, setDefaults] = useState(emptyDefaults);

  useEffect(() => {
    let cancelled = false;
    setDefaults(emptyDefaults);
    if (!savedRobot) return;

    async function getActionDefaults() {
      try {
        const docRef = doc(db, `Companies/Zeeno_Dev/Settings/${savedRobot}/Actions/actionssettings`);
        const docSnapshot = await getDoc(docRef);
        if (cancelled || !docSnapshot.exists()) return;

        const data = docSnapshot.data();
        setDefaults({
          fetchItems: Array.isArray(data.fetch_default_items) ? data.fetch_default_items : [],
          deliverItems: Array.isArray(data.deliver_default_items) ? data.deliver_default_items : [],
        });
      } catch (error) {
        if (!cancelled) console.error("Error fetching action defaults: ", error);
      }
    }

    getActionDefaults();
    return () => { cancelled = true; };
  }, [savedRobot]);

  return defaults;
};

export default useActionDefaultItems;
